import { render, staticRenderFns } from "./DocumentsComments.vue?vue&type=template&id=3f957aab&scoped=true&"
import script from "./DocumentsComments.vue?vue&type=script&lang=js&"
export * from "./DocumentsComments.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsComments.vue?vue&type=style&index=0&id=3f957aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f957aab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f957aab')) {
      api.createRecord('3f957aab', component.options)
    } else {
      api.reload('3f957aab', component.options)
    }
    module.hot.accept("./DocumentsComments.vue?vue&type=template&id=3f957aab&scoped=true&", function () {
      api.rerender('3f957aab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/parts/documents/DocumentsComments.vue"
export default component.exports